<template>
  <div :class="style.header" v-if="!isSetting">
    <div :class="style.content">
      <div :class="style.nameHeader">
        <img
          :src="getLogoQuiz()"
          alt=""
          v-if="
            modifyQuiz('get', '', ['styleName', 'type']) !== 'onlyName' &&
            modifyQuiz('get', '', ['styleName', 'type']) !== undefined
          "
        />

        <h1 v-if="modifyQuiz('get', '', ['styleName', 'type']) != 'onlyLogo'">
          {{ modifyQuiz("get", "", ["companyName"]) }}
        </h1>
      </div>

      <div :class="style.contacts">
        <div
          :class="style.contact"
          v-for="address in addresses"
          :key="`address-${address}`"
          v-if="
            (addresses &&
              modifyQuiz('get', '', ['styleContacts', 'type']) ==
                'onlyAddress') ||
            modifyQuiz('get', '', ['styleContacts', 'type']) == 'both'
          "
        >
          <div :class="style.dot" />
          <p v-text="address" />
        </div>

        <div
          :class="style.contact"
          v-for="phone in phones"
          :key="`phone-${phone}`"
          v-if="
            (phones &&
              modifyQuiz('get', '', ['styleContacts', 'type']) ==
                'onlyPhone') ||
            modifyQuiz('get', '', ['styleContacts', 'type']) == 'both'
          "
        >
          <div :class="style.dot" />
          <p v-text="phone" />
        </div>
      </div>
    </div>

    <ActionVerticalComponent
      v-if="modifyQuiz('get', '', ['actionList'])?.length"
    />
  </div>

  <div :class="style.header" v-else>
    <div :class="style.content">
      <EditableWrapper :typePanel="namePanelData" :disabled="!isSetting">
        <div :class="[style.nameHeader, style.editable]" id="nameCompanyMobile">
          <img
            :src="getLogoQuiz()"
            alt=""
            id="logoLK"
            v-if="
              modifyQuiz('get', '', ['styleName', 'type']) !== 'onlyName' &&
              modifyQuiz('get', '', ['styleName', 'type']) !== undefined
            "
          />

          <AutoResizeTextArea
            placeholder="Введите название"
            :value="modifyQuiz('get', '', ['companyName'])"
            @input="modifyQuiz('set', $event, ['companyName'])"
            v-if="modifyQuiz('get', '', ['styleName', 'type']) != 'onlyLogo'"
          />
        </div>
      </EditableWrapper>

      <EditableWrapper :typePanel="contactsPanelData" :disabled="!isSetting">
        <div :class="[style.contacts, style.editableBlock]" id="contactBlock">
          <div
            :class="[style.contact, style.editable]"
            v-for="(address, index) in addresses"
            :key="`editable-address-${index}`"
            v-if="
              (addresses &&
                modifyQuiz('get', '', ['styleContacts', 'type']) ==
                  'onlyAddress') ||
              modifyQuiz('get', '', ['styleContacts', 'type']) == 'both' ||
              modifyQuiz('get', '', ['styleContacts', 'type']) === undefined
            "
          >
            <div :class="style.dot" />

            <AutoResizeTextArea
              placeholder="Адрес"
              :value="address"
              @input="changeAddress($event, index)"
            />
          </div>

          <div
            :class="[style.contact, style.editable]"
            v-for="(phone, index) in phones"
            :key="`editable-phone-${index}`"
            v-if="
              (modifyQuiz('get', '', ['phone']) &&
                modifyQuiz('get', '', ['styleContacts', 'type']) ==
                  'onlyPhone') ||
              modifyQuiz('get', '', ['styleContacts', 'type']) == 'both' ||
              modifyQuiz('get', '', ['styleContacts', 'type']) === undefined
            "
          >
            <div :class="style.dot" />

            <AutoResizeTextArea
              placeholder="Телефон"
              :value="phones[index]"
              @input="changePhone($event, index)"
            />
          </div>
        </div>
      </EditableWrapper>
    </div>

    <EditableWrapper :typePanel="actionsPanelData" :disabled="!isSetting">
      <ActionVerticalComponent :isSetting="isSetting" id="actionVertical" />
    </EditableWrapper>
  </div>
</template>

<script lang="ts">
import ActionVerticalComponent from "../ActionVerticalComponent/ActionVerticalComponent.vue";
import style from "./HeaderMobile.module.scss";
import ButtonAdd from "@/elements/buttonAdd/ButtonAdd.vue";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";
import {defineComponent} from "vue";
import AutoResizeTextArea from "@/elements/autoResizeTextArea/autoResizeTextArea.vue";
import EditableWrapper from "@/page/quiz/editor/landingPage/components/elements/EditableWrapper/EditableWrapper.vue";
import {Quiz, EditablePanelName} from "@/page/quiz/typeQuiz";
import {DOMAIN} from "@/http";

export default defineComponent({
  name: "HeaderMobile",

  components: {
    AutoResizeTextArea,
    ButtonAdd,
    ActionVerticalComponent,
    EditableWrapper
  },

  props: {
    isSetting: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      style,
      companyName: null as string | null,
      modifyQuiz,
      cachedPreviewUrls: {} as Record<string, string>
    };
  },

  mounted() {
    this.companyName = this.quiz?.companyName || null;
  },

  methods: {
    getCachedFilePreviewUrl(fileName: string): string {
      const cachedFile = this.cachedFiles.find((file: File) => {
        return file.name === fileName;
      });

      if (!cachedFile) {
        return "";
      }

      const currentPreviewUrl = this.cachedPreviewUrls[fileName];

      if (currentPreviewUrl) {
        return currentPreviewUrl;
      }

      const previewUrl = URL.createObjectURL(cachedFile);

      this.cachedPreviewUrls = {
        ...this.cachedPreviewUrls,
        [fileName]: previewUrl
      };

      return previewUrl;
    },

    getServerLogoUrl(path: string): string {
      if (!path) {
        return "";
      }

      if (path.startsWith("blob:")) {
        return path;
      }

      if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
      }

      return "https://" + DOMAIN + "/api/img?name=" + path;
    },

    revokePreviewUrls(): void {
      Object.values(this.cachedPreviewUrls).forEach((url) => {
        if (url.startsWith("blob:")) {
          URL.revokeObjectURL(url);
        }
      });

      this.cachedPreviewUrls = {};
    },

    changePhone(event: Event, index: number) {
      const target = event.target as HTMLInputElement;
      this.duplicateToABTest("phone", "phones");
      this.modifyQuiz("set", target.value, ["phone", index]);
    },

    changeAddress(event: Event, index: number) {
      const target = event.target as HTMLInputElement;
      this.duplicateToABTest("address", "addresses");
      this.modifyQuiz("set", target.value, ["address", index]);
    },

    duplicateToABTest(key: "phone" | "address", data: "phones" | "addresses") {
      if (!this.quiz?.ABTestBool) {
        return;
      }

      const sourceData = this[data];

      if (!sourceData) {
        return;
      }

      const normalizedData = Array.isArray(sourceData)
        ? [...sourceData]
        : [...Object.values(sourceData)];

      if (this.mobileVersion) {
        if (!this.quiz.mobileVersionQuiz) {
          this.quiz.mobileVersionQuiz = {};
        }

        if (!this.quiz.mobileVersionQuiz.ABTestObj) {
          this.quiz.mobileVersionQuiz.ABTestObj = {
            [key]: normalizedData
          };
          return;
        }

        if (!this.quiz.mobileVersionQuiz.ABTestObj[key]) {
          this.quiz.mobileVersionQuiz.ABTestObj[key] = normalizedData;
        }

        return;
      }

      if (!this.quiz.ABTestObj) {
        this.quiz.ABTestObj = {
          [key]: normalizedData
        };
        return;
      }

      const ABTestObj = this.quiz.ABTestObj as {[key: string]: string[]};

      if (!ABTestObj[key]) {
        ABTestObj[key] = normalizedData as string[];
      }
    },

    getLogoQuiz() {
      const modifiedLogo = this.modifyQuiz("get", "", ["logo"]) as
        | string
        | undefined;

      if (modifiedLogo) {
        const cachedPreviewUrl = this.getCachedFilePreviewUrl(modifiedLogo);

        if (cachedPreviewUrl) {
          return cachedPreviewUrl;
        }

        return this.getServerLogoUrl(modifiedLogo);
      }

      const abtest = Boolean(localStorage.getItem("ABTest"));
      const abtestobj = this.quiz?.ABTestObj as {logo?: string} | undefined;

      if (!abtest && this.quiz?.logo) {
        const cachedPreviewUrl = this.getCachedFilePreviewUrl(this.quiz.logo);

        if (cachedPreviewUrl) {
          return cachedPreviewUrl;
        }

        return this.getServerLogoUrl(this.quiz.logo);
      }

      if (abtest && abtestobj?.logo) {
        return this.getServerLogoUrl(abtestobj.logo);
      }

      return "https://readds.ru/api/img?name=readds.svg";
    }
  },

  computed: {
    quiz(): Quiz {
      return this.$quizStore.getQuiz;
    },

    mobileVersion(): boolean {
      return this.$quizStore.getMobileVersion;
    },

    mobileLKVersion(): boolean {
      return this.$quizStore.getSelectedVersion === "Мобильная";
    },

    namePanelData(): EditablePanelName {
      return "logo";
    },

    contactsPanelData(): EditablePanelName {
      return "contacts";
    },

    actionsPanelData(): EditablePanelName {
      return "actions";
    },

    phones(): string[] {
      const phones = this.modifyQuiz("get", "", ["phone"]);

      if (!phones && this.quiz?.phone) {
        this.modifyQuiz(
          "set",
          typeof this.quiz.phone === "string"
            ? [this.quiz.phone]
            : this.quiz.phone,
          ["phone"]
        );
      }

      const normalizedPhones = this.modifyQuiz("get", "", ["phone"]);

      if (Array.isArray(normalizedPhones)) {
        return normalizedPhones;
      }

      if (normalizedPhones && typeof normalizedPhones === "object") {
        return Object.values(normalizedPhones) as string[];
      }

      return [];
    },

    addresses(): string[] {
      const address = this.modifyQuiz("get", "", ["address"]);

      if (!address && this.quiz?.address) {
        this.modifyQuiz(
          "set",
          typeof this.quiz.address === "string"
            ? [this.quiz.address]
            : this.quiz.address,
          ["address"]
        );
      }

      const normalizedAddresses = this.modifyQuiz("get", "", ["address"]);

      if (Array.isArray(normalizedAddresses)) {
        return normalizedAddresses;
      }

      if (normalizedAddresses && typeof normalizedAddresses === "object") {
        return Object.values(normalizedAddresses) as string[];
      }

      return [];
    },

    cachedFiles(): File[] {
      return this.$quizStore.getCachedFiles;
    }
  },

  watch: {
    cachedFiles(): void {
      Object.values(this.cachedPreviewUrls).forEach((url) => {
        if (url.startsWith("blob:")) {
          URL.revokeObjectURL(url);
        }
      });

      this.cachedPreviewUrls = {};
    }
  }
});
</script>
